import { useMemo } from "react";
import PropTypes from "prop-types";
import { AsyncDataGridExportContext } from "./AsyncDataGridExportContext.js";

/**
 * Provides export context for AsyncDataGrid toolbar and export menu.
 *
 * @param {Object} props
 * @param {Array} props.exportRows
 * @param {boolean} props.exportLoading
 * @param {Object} props.exportConfig
 * @param {Array} props.gridColumns
 * @param {boolean} props.isServerMode
 * @param {boolean} props.hideExport
 * @param {import('react').ReactNode} props.children
 */
function AsyncDataGridExportProvider({
  exportRows,
  exportLoading,
  exportConfig,
  gridColumns,
  isServerMode,
  hideExport,
  children,
}) {
  const exportContextValue = useMemo(
    () => ({
      rows: exportRows,
      loading: exportLoading,
      exportConfig,
      gridColumns,
      isServerMode,
      hideExport,
    }),
    [exportRows, exportLoading, exportConfig, gridColumns, isServerMode, hideExport],
  );

  return (
    <AsyncDataGridExportContext.Provider value={exportContextValue}>{children}</AsyncDataGridExportContext.Provider>
  );
}

AsyncDataGridExportProvider.propTypes = {
  exportRows: PropTypes.array.isRequired,
  exportLoading: PropTypes.bool.isRequired,
  exportConfig: PropTypes.object.isRequired,
  gridColumns: PropTypes.array.isRequired,
  isServerMode: PropTypes.bool.isRequired,
  hideExport: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export default AsyncDataGridExportProvider;
